import { GetAllPostsByAppVariantAndSelectedGeoAreasSortByEnum } from '@DigitaleDoerfer/digitale-doerfer-api';

export const PostSortEnum = {
  LastActivity:
    GetAllPostsByAppVariantAndSelectedGeoAreasSortByEnum.LastActivity,
  Created: GetAllPostsByAppVariantAndSelectedGeoAreasSortByEnum.Created
} as const;

export type PostSortEnum = (typeof PostSortEnum)[keyof typeof PostSortEnum];

export const HappeningSortEnum = {
  LastActivity:
    GetAllPostsByAppVariantAndSelectedGeoAreasSortByEnum.LastActivity,
  Created: GetAllPostsByAppVariantAndSelectedGeoAreasSortByEnum.Created,
  HappeningStart:
    GetAllPostsByAppVariantAndSelectedGeoAreasSortByEnum.HappeningStart
} as const;

export type HappeningSortEnum =
  (typeof HappeningSortEnum)[keyof typeof HappeningSortEnum];
